import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GeneralService } from 'src/app/services/general/general.service';
import { RouterService } from 'src/app/services/router/router.service';
import { UserService } from 'src/app/services/user/user.service';
import { LoginType, SystemNavigateReason } from '../interfaces/log';
import { SnackbarService } from '../services/snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private userService: UserService, private routerService: RouterService, private snackbarService: SnackbarService, private generalService: GeneralService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // 해당 라우트 block
      if (route.data['blockForWeb']) {
        return false;
      }
      return new Observable<boolean>((observer) => {
        if (this.userService.isLoggedIn) {
          if (this.isUserDataSetProperly) {
            observer.next(true);
          } else {
            this.userService.getProfile().subscribe(() => {
              if (this.isUserDataSetProperly) {
                observer.next(true);
              } else {
                this.snackbarService.openSnackBar('예상치 못한 오류가 발생했습니다. 다시 실행해주세요.');
                observer.next(false);
              }
            }, error => {
              console.error(error)
              this.snackbarService.openSnackBar('예상치 못한 오류가 발생했습니다. 다시 실행해주세요.');
              observer.next(false);
            })
          }
        } else {
          this.routerService.navigate('login', {queryParams: {to: state.url, type: LoginType.AUTH_GUARD}}, 'system', { reason: SystemNavigateReason.ACCESS_DENIED });
          observer.next(false);
        }
      });
  }
  
  private get isUserDataSetProperly(): boolean {
    return this.userService.user.id > 0
  }
}
